import { useState } from 'react';
import '../brief/evidence.css';
import './caveats.css';

/**
 * The hedging beside a section, never inside it (2026-08-31, Soroush —
 * docs/notes/2026-08-31-first-prod-runs.md §2). Match strength, which anchors
 * carried the identification, where the record is thin: useful, and not what a
 * summary is for. It rides the analysis payload as its own field and renders
 * here as "Source notes · N", closed, on the same disclosure a research panel's
 * evidence uses (blend spec, "Depth on demand").
 *
 * A section whose analysis carries no caveats renders exactly as it did before
 * this existed.
 */
export function Caveats({ caveats }: { caveats: string[] }) {
  const [open, setOpen] = useState(false);
  if (caveats.length === 0) return null;

  return (
    <div className="caveats">
      <button
        type="button"
        className="disclose-plus"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        Source notes<span className="quiet"> · {caveats.length}</span>
      </button>
      {open ? (
        <div className="caveats-body">
          {caveats.map((line, index) => (
            <div className="caveat" key={`${index}-${line}`}>
              {line}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
